<div class="maintenance-wrapper">

  <div class="maintenance-card">

    <div class="maintenance-illustration">
      <img src="assets/images/Maintenance/Maintenance.png" alt="Maintenance">
    </div>

    <h1 class="maintenance-title">{{ data.title.en }}</h1>
    <p class="maintenance-body">{{ data.body.en }}</p>
  </div>

</div>